import React from 'react';
import FieldModal from '../../../../components/modals/fieldModal';
import API from '../../../../utils/API';

class ApproveWaitlistModal extends React.Component {
	state = {
		submitting: false
	};

	approveAttendees = async () => {
		const { orgId, eventId, group, existingAttendees, existingWaitlist, checkedWaitlist } = this.props;

		const approvingIds = Object.keys(checkedWaitlist);
		const approvingAttendees = existingWaitlist.filter((a) => approvingIds.includes(a._id));
		const existingAttendeeIds = existingAttendees.map((a) => a._id);
		const newAttendees = approvingAttendees.filter((a) => !existingAttendeeIds.includes(a._id));

		this.setState({ submitting: true });

		await API()
			.patch(`Organizations/${orgId}/events/${eventId}/groups/${group._id}`, {
				attendees: [
					...existingAttendees.map((a) => a._id),
					...newAttendees.map((a) => a._id)
				],
				waitlist: existingWaitlist
					.filter((a) => !approvingIds.includes(a._id))
					.map((a) => a._id)
			})
			.then((res) => {
				if (res.data) {
					this.props.approveWaitlistAttendees(approvingAttendees, newAttendees);
					this.props.toggle();
				}
			})
			.catch((e) => {
				console.log(e);
				this.setState({ submitting: false });
			});
	};

	render() {
		const { isOpen, toggle, checkedWaitlist } = this.props;
		const { submitting } = this.state;
		const count = Object.keys(checkedWaitlist).length;

		return (
			<FieldModal
				size="small"
				isOpen={isOpen}
				modalTitle="Approve Waitlist Attendees"
				bodyHeaderText={
					<span>
						You are about to approve{' '}
						<b>
							{count} attendee{count !== 1 && 's'}
						</b>{' '}
						from the waitlist and add them to the group. Would you like to continue?
					</span>
				}
				bodyContent={() => ''}
				toggle={toggle}
				actionButtonLabel={!submitting ? 'Approve' : 'Approving...'}
				actionButton={this.approveAttendees}
				actionButtonDisabled={submitting}
			/>
		);
	}
}

export default ApproveWaitlistModal;
